var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "TableSandbox" } }, [
    _c("div", { staticClass: "header" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "header-text" }, [
        _c("h1", [_vm._v(_vm._s(_vm.$t("tables.sandboxTitle")))]),
        _vm._v(" "),
        _c("p", [_vm._v(_vm._s(_vm.$t("tables.sandboxDesc")))]),
      ]),
    ]),
    _vm._v(" "),
    _vm.loading
      ? _c(
          "div",
          { staticClass: "tables-loading" },
          _vm._l(3, function (skltn) {
            return _c(
              "div",
              { key: skltn, staticClass: "table table-skeleton" },
              [
                _c("a-skeleton", {
                  attrs: { active: true, paragraph: { rows: 3 } },
                }),
              ],
              1
            )
          }),
          0
        )
      : _vm.deletedTables.length === 0
      ? _c("div", { staticClass: "empty-state" }, [
          _c("i", { staticClass: "material-icons" }, [
            _vm._v("delete_outline"),
          ]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.$t("tables.sandboxEmpty")))]),
        ])
      : _c(
          "div",
          { staticClass: "tables" },
          _vm._l(_vm.deletedTables, function (table) {
            return _c(
              "div",
              {
                key: table._id || table.id,
                staticClass: "table table-deleted",
              },
              [
                _c(
                  "div",
                  { staticClass: "table-header" },
                  [
                    _c("div", { staticClass: "table-title" }, [
                      _vm._v(
                        _vm._s(table.name || _vm.$t("tables.unnamedTable"))
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "a-popover",
                      {
                        staticClass: "table-menu-content",
                        attrs: { trigger: "click" },
                      },
                      [
                        _c(
                          "div",
                          { attrs: { slot: "content" }, slot: "content" },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "table-menu-popover-items",
                                on: {
                                  click: function ($event) {
                                    return _vm.restoreTable(table)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  [
                                    _c("a-icon", {
                                      staticClass: "px-1",
                                      attrs: { type: "undo" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("tables.restore"))),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "table-menu-popover-items danger-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.permanentlyDeleteTable(table)
                                  },
                                },
                              },
                              [
                                _c(
                                  "span",
                                  [
                                    _c("a-icon", {
                                      staticClass: "px-1",
                                      attrs: { type: "delete" },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.$t("tables.permanentlyDelete"))
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-button",
                          {
                            staticClass: "table-menu-btn",
                            on: {
                              click: function (e) {
                                return e.stopPropagation()
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("more_vert"),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "table-content" }, [
                  table.description
                    ? _c("div", { staticClass: "table-description" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(table.description) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "table-meta" }, [
                    _c("div", { staticClass: "meta-item" }, [
                      _c("i", { staticClass: "material-icons" }, [
                        _vm._v("schedule"),
                      ]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.formatDeletedDate(table.trashedAt))),
                      ]),
                    ]),
                    _vm._v(" "),
                    table.trashedBy
                      ? _c("div", { staticClass: "meta-item" }, [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("person"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.getDeletedByText(table.trashedBy))
                            ),
                          ]),
                        ])
                      : _vm._e(),
                  ]),
                ]),
              ]
            )
          }),
          0
        ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("delete_outline")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }